import { Button, Col, Popconfirm, Popover, Row } from 'antd'
import React, { useContext } from 'react'
import { t } from 'i18next'
import { ActionButton } from '../../Common/Common'
import LoginContext from '../LoginContext'

export default function AdminAppointmentActions ({ form, appointment, cancel, back, delay }) {
  const { user } = useContext(LoginContext)

  return (
    <Row>
      <Col span={8} style={{ display: 'flex', justifyContent: 'space-evenly' }}>
        <Popconfirm
          title={t('Admin.AdminAppointmentPage.cancelAppointment')}
          onConfirm={cancel}
          okText={t('Admin.message.yes')}
          cancelText={t('Admin.message.no')}
        >
          <Button danger disabled={appointment.is_cancel || user.roles.includes('reader')}>
            {t('Admin.btn.cancel')}
          </Button>
        </Popconfirm>
        {appointment.delayable &&
          <Popconfirm
            title={t('Admin.AdminAppointmentPage.delayAppointment')}
            onConfirm={delay}
            okText={t('Admin.message.yes')}
            cancelText={t('Admin.message.no')}
          >
            <Button type='primary' disabled={!appointment.delayable || user.roles.includes('reader')}>
              {t('Admin.btn.delay')}
            </Button>
          </Popconfirm>
        }
        {!appointment.delayable &&
          <Popover content={t('Admin.AdminAppointmentPage.cannotDelay')}>
            <Button type='primary' disabled>
              {t('Admin.btn.delay')}
            </Button>
          </Popover>
        }
      </Col>
      <Col span={10} />
      <Col span={6} style={{ float: 'right', display: 'flex', justifyContent: 'space-evenly' }} >
        <Button type="primary" onClick={back}>
          {t('Admin.btn.back')}
        </Button>
        <ActionButton type="primary" htmlType="submit" onClick={form.submit} disabled={appointment.is_cancel}>
          {t('Admin.btn.submit')}
        </ActionButton>
      </Col>
    </Row>
  )
}
